import { createSlice } from "@reduxjs/toolkit";

const Frameslice = createSlice({
    name : "frame",
    initialState : {
        loading : false,
        products : []
    },
    reducers:{
        productsrequest : (state,action)=>{
            state.loading = true
            console.log(state.loading)

        },
        productssuccess : (state,action)=>{
            state.loading = false
            state.products = action.payload
            console.log(state.loading)
            console.log(state.products)
            
        },
        productsfail : (state,action) =>{
            state.loading = false

        }
    }
})
export default Frameslice;